{
  "floating_button": {
    "text": "جاهز للمحاولة"
  },
  "header_content": {
    "title": "حاول قبل شراء ®",
    "subtitle": "جرب ما يصل إلى 4 سجاد مجانًا في مساحتك!",
    "description": "أحبها؟احتفظ بها,لا؟سنتعامل مع الباقي."
  },
  "try_bundler_content": {
    "heading": "أضف وسائد متطابقة 🎨",
    "first_description": {
      "first_text": "يمكنك اختيار ",
      "second_text": {
        "bold_text": "حزمة واحدة"
      },
      "third_text": "للتجربة —",
      "fourth_text": {
        "bold_text": "مجانًا تمامًا!"
      },
      "fifth_text": "اختر من بين حزم الوسائد المُختارة بعناية لتناسب سجادك."
    },
    "left_button_text": "تخطي هذه الخطوة",
    "right_button_text": "عرض المزيد من خيارات الوسائد",
    "product_id_text": "معرف المنتج"
  },
  "cushion_recommendations": {
    "title": "اختر حزمة وسائد واحدة لتجربتها مع سجادك.",
    "add_for_trial": "أضف للتجربة",
    "continue_without_cushions": "تواصل بدون وسائد"
  },
  "summary": {
    "text_one": "إليك ما اخترته حتى الآن",
    "text_two": "السجاد المختار",
    "text_three": "حزمة الوسائد",
    "button_text": "حدّد موعد تجربتك المجانية"
  },
  "schedule": {
    "emirate_text": "الإمارة",
    "available_date_text": "حدد تاريخًا متاحًا",
    "previous_text": "السابق",
    "next_text": "التالي",
    "select_time_text": "حدد الوقت",
    "contact_details_text": "تفاصيل الاتصال",
    "phone_number_text": "رقم الهاتف",
    "country_code_text": "الإمارات (+971)",
    "form": {
      "label": {
        "name": "الاسم",
        "email": "البريد الإلكتروني",
        "address": "العنوان"
      },
      "placeholder": {
        "select": "يختار",
        "name": "أدخل الاسم",
        "email": "أدخل البريد الإلكتروني",
        "phone": "أدخل الهاتف لا.",
        "address": "أدخل العنوان"
      },
      "error": {
        "went_wrong": "حدث خطأ ما.من فضلك حاول مرة أخرى.",
        "valid_number": "أدخل رقم هاتف الإمارات صالح",
        "incomplete": "رقم غير صالح أو تنسيق غير صحيح",
        "invalid": "رقم هاتف الإمارات العربي غير صالح"
      }
    }
  },
  "render_description_content": {
    "text_one": "حدّد موعد توصيل التجربة المجانية",
    "text_two": "الملخص"
  },
  "render_title_content": {
    "text_one": "مراجعة وتأكيد"
  },
  "review": {
    "text_one": "السجاد الذي اخترته",
    "text_two": "حزمة الوسائد",
    "text_three": "التاريخ والوقت المحددان",
    "date_text": "التاريخ",
    "time_text": "الوقت",
    "contact_details_text": "بيانات الاتصال الخاصة بك",
    "confirm_and_continue": "تأكيد ومتابعة"
  },
  "schedule_free_trial_button_text": "جدول تجربتك المجانية",
  "confirm_and_continue_text": "تأكيد ومتابعة",
  "success": {
    "title": "أنت كل مجموعة!",
    "description": "بمجرد التأكيد ، سنقوم بجدولة تجربتك ونرسل لك تأكيدًا عبر واتساب"
  }
}
